import React, { useCallback } from 'react';
import { useEffect, useRef, useState } from 'react';
import styles from './SeachInputControl.module.scss';
import { SearchIcon } from '../internal/icons/SearchIcon';

export interface SearchInputControlProps {
    onSubmit: (query: string) => void;
    onBack: () => void;
    status: 'pre-search' | 'post-search';
    extKey: number;
    placeholder?: string;
}

export const SearchInputControl = ({
    placeholder = 'What is happening this weekend?',
    onSubmit,
    ...props
}: SearchInputControlProps) => {
    const [query, setQuery] = useState('');
    const inputRef = useRef<HTMLTextAreaElement | null>(null);
    const [extKey, setExtKey] = useState(props.extKey);

    useEffect(() => {
        if (props.extKey !== extKey) {
            inputRef.current?.focus();
            setExtKey(props.extKey);
        }
    }, [inputRef, extKey, props.extKey]);

    const handleSubmit = useCallback(() => {
        const trimmedQuery = query.trim();
        if (trimmedQuery.length > 0) {
            onSubmit(query);
            setQuery('');
        }
    }, [onSubmit, query, setQuery]);

    return (
        <div className={styles.inputContainer}>
            <div className={styles.input}>
                {props.status === 'pre-search' ? (
                    <div className={styles.searchIcon}>
                        <SearchIcon />
                    </div>
                ) : (
                    <></>
                )}
                <div className={styles.textInput}>
                    <textarea
                        ref={inputRef}
                        className={styles.inputControl}
                        placeholder={placeholder}
                        value={query}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit();
                            }
                        }}
                        onChange={(event) => {
                            const changedValue = event.target.value;
                            if (!changedValue.endsWith('\n')) {
                                setQuery(changedValue);
                            }
                        }}
                    ></textarea>
                </div>
                {props.status === 'post-search' ? (
                    <div className={styles.searchIcon} onClick={handleSubmit}>
                        <SearchIcon fill="#ffffff" />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
